import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ModalAddTradeAgreementComponent } from '../modal-add-trade-agreement/modal-add-trade-agreement.component';
import { ModalMessageComponent } from '../modal-message/modal-message.component';

@Component({
  selector: 'app-modal-user-information',
  templateUrl: './modal-user-information.component.html',
  styleUrls: ['./modal-user-information.component.scss']
})
export class ModalUserInformationComponent implements OnInit {

  modalForm: FormGroup = new FormGroup({
    first_name: new FormControl('', Validators.required),
    last_name: new FormControl('', Validators.required),
    email: new FormControl('', Validators.required),
    cellphone: new FormControl('', Validators.required),
  });

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private uService: UtilsService,
    private toast: ToastrService,
    private mService: MainService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalUserInformationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    if(data != undefined){
      console.log(data);

      this.modalForm.get('first_name').setValue(data.item.first_name);
      this.modalForm.get('last_name').setValue(data.item.last_name);
      this.modalForm.get('email').setValue(data.item.email);
      this.modalForm.get('cellphone').setValue(data.item.cellphone);
    }

  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  dismiss(data?) {
    this.dialogRef.close( null );
  }

  saveUser(){
    if(this.modalForm.valid){
      var body = this.modalForm.value;
      body.customer_id = this.data.item.id;
      body.business_id = this.data.id_row;

      this.mService.post_request('qpos/update/customer-user', body)
      .subscribe((resp: any)=>{
        if(resp.status){
          this.toast.success(resp.message, 'Éxito', {timeOut: 5000, progressBar: true, closeButton: true});
          this.dismiss();
        }
      });
    }else{
      this.uService.validateForm(this.modalForm);
    }
  }

  resetPassword(){
    if(this.modalForm.valid){
      // var body = { id: this.data.id_row };
      var body = this.modalForm.value;
      body.customer_id = this.data.item.id;
      body.business_id = this.data.id_row;

      this.mService.post_request('qpos/reset-password-user', body)
      .subscribe((resp: any)=>{
        if(resp.status){
          this.toast.success(resp.message, 'Éxito', {timeOut: 5000, progressBar: true, closeButton: true});
        }
      });
    }else{
      this.uService.validateForm(this.modalForm);
    }
  }
}

